export default {
  'home.join.title':
    '<h3>協會規範與入會須知</h3>' +
    '<b>歡迎您對多肉男子文化有興趣，並希望成為我們的一份子！</b>' +
    '<br />' +
    '為維護協會運作秩序與會員的交流品質，請詳細閱讀以下規範與入會條件，並確認您理解並同意遵守。',
  'home.join.paragraph_1':
    '<h4>📌 入會資格 </h4>' +
    '<ol>' +
    '<li>' +
    '<b>年齡與身分要求</b>：<br />' +
    '申請人須為依法定年齡具有自主法律責任之<b>成年男性</b>。' +
    '</li>' +
    '<li>' +
    '<b>性別與性傾向條件</b>：<br />' +
    '本協會服務對象為<b>生理男性且性取向為男性</b>' +
    '的族群。這並非基於歧視，而是源於協會宗旨與文化定位——如同素食餐廳專門提供蔬食、女性空間限制異性進入，我們僅招收特定身分族群，是為了讓該族群有安心、安全的文化交流空間。請互相尊重。' +
    '</li>' +
    '<li>' +
    '<b>價值觀認同</b>：<br />' +
    '申請人需<b>理解並認同協會的宗旨</b>' +
    '，願意參與GMPD文化的推廣與支持，並以尊重、友善的態度對待社群成員。' +
    '</li>' +
    '</ol>',
  'home.join.paragraph_2':
    '<h4>🚫 禁止行為</h4>' +
    '為維護協會形象與會員權益，以下行為<b>一律禁止</b>，違者將視情節嚴重性，酌予警告、停權或取消會員資格：' +
    '<ul>' +
    '<li>' +
    '<b>對男同性戀者進行歧視或侮辱性的言語與行為</b>' +
    '</li>' +
    '<li>' +
    '<b>對多元體型（無論胖瘦）進行歧視或侮辱性的言語與行為</b>' +
    '</li>' +
    '<li>' +
    '<b>活動期間或線上互動中，違反規範、破壞秩序，損害協會形象</b>' +
    '</li>' +
    '<li>' +
    '<b>以協會名義進行騷擾、侵犯、詐欺、誤導等不當行為</b>' +
    '</li>' +
    '</ul>',
  'home.join.paragraph_3':
    '<h4>✍️ 入會流程</h4>' +
    '<ol>' +
    '<li>' +
    '<b>填寫會員申請表單</b>' +
    '<br />' +
    '請誠實填寫個人基本資料與自我介紹，內容僅供審核與內部管理，不會對外公開。' +
    '</li>' +
    '<li>' +
    '<b>閱讀與同意會員條款</b>' +
    '<br />' +
    '確認您完全了解本頁規範內容，並願意遵守所有協會規則。' +
    '</li>' +
    '<li>' +
    '<b>審核與聯繫</b>' +
    '<br />' +
    '協會將進行審核，確認身分條件與申請動機是否符合宗旨，審核結果將以Email方式通知。' +
    '</li>' +
    '</ol>',
  'home.join.paragraph_4':
    '<h4>🤝 一起打造友善空間</h4>' +
    '我們希望打造一個屬於多肉男子的歸屬空間，不論您是P、M、G、D的哪一種體型，只要您願意尊重、理解與彼此支持，我們都誠摯地歡迎您加入。',
  'home.join.paragraph_5':
    '如果您有任何疑問，歡迎透過聯絡表單或社群平台與我們聯繫。',
  'home.purpose.title':
    '<h3>協會介紹與宗旨</h3>' +
    '<b>多肉男子文化推廣協會</b>' +
    '是一個致力於推廣GMPD文化的民間社群組織。我們以尊重多樣體型、建立正向價值為核心，希望在台灣建立一個支持、理解並歡迎大體型男性的社群空間。',
  'home.purpose.paragraph_1':
    '<h4>協會介紹</h4>' +
    'GMPD文化源自日本，關注的是四種具有份量與魅力的體型特質：' +
    '<ul>' +
    '<li>' +
    '<b>G（ガッチリ）</b>：肌肉肥大、體格健壯的壯壯體型' +
    '</li>' +
    '<li>' +
    '<b>M（ムッチリ）</b>：略帶脂肪、彈性飽滿的肉壯體型' +
    '</li>' +
    '<li>' +
    '<b>P（ぽっちゃり）</b>：圓潤可愛、微胖溫柔的肉肉體型' +
    '</li>' +
    '<li>' +
    '<b>D（デブ）</b>：柔軟豐滿、帶有存在感的胖胖體型' +
    '</li>' +
    '</ul>',
  'home.purpose.paragraph_2':
    '在主流社會中，「肥胖」經常被視為負面的標籤，甚至與病態直接劃上等號。但醫學研究顯示，體型與健康之間的關係並非單純對等，許多與肥胖相關的疾病實際上與基因、環境、生活型態等多重因素交錯影響。因此，將所有非標準體型視為病態，是不嚴謹也不負責任的判斷。' +
    '<br />' +
    '我們相信，<b>體型的多樣性本身就是一種文化，也是一種美</b>。多肉男子文化推廣協會並非為了否定健康的重要性，而是希望從社會與心理層面給予每一位天生或選擇成為「多肉男子」的朋友，一個可以安心做自己的空間。',
  'home.purpose.paragraph_3':
    '<h4>協會宗旨</h4>' +
    '<i>我們可能無法消彌世上對體型的歧視，</i>' +
    '<br />' +
    '<i>但我們希望至少能創造一個地方，讓每個多肉男子與喜愛這樣體型的人們，</i>' +
    '<br />' +
    '<i>彼此認識、互相理解、分享生活、照顧彼此。</i>',
  'home.purpose.paragraph_4':
    '我們的主要活動包括：' +
    '<ol>' +
    '<li>' +
    '<b>文化交流活動</b>：舉辦書展、同人誌販售會、創作交流會等，以藝術與創作推廣多肉男子文化。' +
    '</li>' +
    '<li>' +
    '<b>健康與體型交流</b>：分享健康資訊、健身知識與體型調整經驗，提供彼此支持與鼓勵。' +
    '</li>' +
    '<li>' +
    '<b>知識內部交流</b>：收藏與分享國內外相關出版品、研究與文化作品，累積文化資產。' +
    '</li>' +
    '</ol>',
};
